import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { getConfig } from 'config'

const config = await getConfig()

const history = createBrowserHistory()
const reactPlugin = new ReactPlugin()

const appName = 'univers-customer-portal'

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: `${config.appInsightsKey}`,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history },
    },
  },
})

appInsights.addTelemetryInitializer((envelope) => {
  if (envelope.tags) {
    envelope.tags['ai.cloud.role'] = appName
  }

  envelope.data = envelope.data || {}
  envelope.data.properties = envelope.data.properties || {}
  envelope.data.properties.appName = appName
})

appInsights.loadAppInsights()

export { appInsights, reactPlugin }
